import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { ProveScritteFormComponent } from '../../../form/prove-scritte/prove-scritte-form.component';

import { ProvaScritta } from '../../../models/prova-scritta';
import { SezioneProveScritte } from '../../../models/sezioni/sezione-prove-scritte';

@Component({
    selector: 'div [prova-scritta-form-add]',
  templateUrl: '../../../form/prove-scritte/prove-scritte-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class ProveScritteAddFormComponent extends ProveScritteFormComponent implements OnInit {

  idSezione: string;
  urlAddProvaScritta: string;
  idFascicolo: string;
  @Output()
  onReturn: EventEmitter<SezioneProveScritte> = new EventEmitter<SezioneProveScritte>();

  constructor(@Inject(OperationsService) operationService: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(HelpersService) helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Prova scritta');
    this.populateSelect();
    this.isInserimento(true);
  }

  getProvaScritta() {
    return new ProvaScritta();
  }

  getRequest(request: ProvaScritta) {
    this.operationService.addProvaScritta(this.urlAddProvaScritta, request, this.idSezione, this.idFascicolo).subscribe(response => this.updateSezioneProveScritte(response));
  }

  updateSezioneProveScritte(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(url: string, idSezione: string, idFascicolo: string) {
    this.urlAddProvaScritta = url;
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.createForm();
  }
}
